import { render } from "./greeting.vue?vue&type=template&id=414fcb12&scoped=true"
import script from "./greeting.vue?vue&type=script&lang=js"
export * from "./greeting.vue?vue&type=script&lang=js"

import "./greeting.vue?vue&type=style&index=0&id=414fcb12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414fcb12"]])

export default __exports__